//libs
import { useCallback, useEffect, useState } from 'react';
import { useWindowSize } from 'react-use';

import { getEditorWidth } from '@lyearn/lygo-core';

//utils
import { calMaxWidth } from '../utils';

const DEFAULT_WIDTH = 700;

const getAdjustedWidth = (width: number, maxWidth: number, editorWidth: number) => {
  // Previously, we were storing width in the pixel. We have changed it now
  // and saving the width in the percentage. So if by any means, width is
  // above 100, we will set it to default percentage of 40%.
  if (!width || width > 100) {
    return (editorWidth * 100) / maxWidth;
  }

  return width;
};

const useCalculatedWidthV2 = (width: number, useResize: boolean = false) => {
  const setCalculatedWidthFunc = useCallback(() => {
    const editorWidth = getEditorWidth() || DEFAULT_WIDTH;
    const maxWidth = calMaxWidth();
    const migrationWidth = getAdjustedWidth(width, maxWidth, editorWidth);
    const resizedWidth = (maxWidth * migrationWidth) / 100;
    return resizedWidth;
  }, [width]);

  /* recalculate width if window width changes */
  const { width: windowWidth } = useWindowSize();
  const widthDep = useResize ? windowWidth : null;

  /**
   * Changed default value from 0 to setCalculatedWidthFunc Func,
   *  because if not then this hook would return 0 on initial render
   */
  const [calculatedWidth, setCalculatedWidth] = useState<number>(setCalculatedWidthFunc);

  useEffect(() => {
    const resizedWidth = setCalculatedWidthFunc();
    setCalculatedWidth(resizedWidth);
    window.addEventListener('resize', setCalculatedWidthFunc);
    return () => {
      window.removeEventListener('resize', setCalculatedWidthFunc);
    };
  }, [setCalculatedWidthFunc, widthDep]);

  return calculatedWidth;
};

export { useCalculatedWidthV2 };
